"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEkg = createEkg;
const events_1 = require("../../../events");
const queries_1 = require("../queries");
const ekg_1 = require("../../../forms/htx/current-cardiological-state/ekg");
const messages = {
    ekg: {
        id: "dashboard.ekg",
        defaultMessage: "EKG"
    },
    happened: {
        id: "dashboard.ekg.happened",
        defaultMessage: "Történt vizsgálat"
    },
    notHappened: {
        id: "dashboard.ekg.not_happened",
        defaultMessage: "Nem történt vizsgálat"
    }
};
function createEkg({ formatMessage }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.ekg);
    if (event === undefined) {
        return undefined;
    }
    const { value, timestamp, sid, origin } = event;
    if (value === ekg_1.Result.NO) {
        return {
            type: "record",
            attachments: (0, events_1.mapEventsToAttachments)(event),
            value: formatMessage(messages.notHappened),
            label: formatMessage(messages.ekg),
            timestamp,
            sid,
            origin
        };
    }
    if (value === ekg_1.Result.YES) {
        return {
            type: "record",
            attachments: (0, events_1.mapEventsToAttachments)(event),
            value: formatMessage(messages.happened),
            label: formatMessage(messages.ekg),
            timestamp,
            sid,
            origin
        };
    }
    return undefined;
}
